<script>
import {
  requiredIf
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
  name: 'CreateModal',
  props:[
    "list"
  ],
  data() {
    return {
      options: [],
      form: {
        subtype : 'n',
        password: ''
      },
      submitted: false,
      ilList : [],
      bucakList:[],
    };
  },
  validations: {
    
    form: {
      name: {  
        required:requiredIf(function () {
          return this.form.type != 'password'
        })  
      },
      phonenumber: {  
        required:requiredIf(function () {
          return this.form.type != 'password'
        })  
      },
      address: {  
        required:requiredIf(function () {
          return this.form.type != 'password'
        })  
      },
      password: {  
        required:requiredIf(function () {
          return this.form.type != 'update'
        })  
      },
      username: {  
        required:requiredIf(function () {
          return this.form.type != 'password'
        })  
      },
      authorized_name: {  
        required:requiredIf(function () {
          return this.form.type != 'password'
        })  
      },
    },
  },
  watch:{
    list(props){
      this.form = {...props}
      this.setSelected({ id : 0},'il')
    }
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) return;
   
      if(this.form.id)
        this.update();
      else
        this.create(); 

      this.$emit('loadItems');
      this.submitted = false;
    },
    create(){
      this.$http.post('/dealers/store', this.form)
        .then(resp => {
          this.form = {};
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    update(){
      this.$http.put('/dealers/' + this.form.id , this.form)
        .then(resp => {
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    remove(id){
      this.$http.delete('/dealers/' + id)
        .then(resp => {
          if(resp.data.code !==  100)  return notify.error(resp.data.message)
           return notify.success(resp.data.message)
         })
        .catch(error => error)
    },
    async setSelected(val,event){
        const object = event + 'List' 
        const { id } = val
        const response = await this.$http.post(`/address/${event}/${id}`)
        if(response.data.error) return;
        this[object] = response.data;
    },

    generatePassword() {
      const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
      const numbers = "0123456789";
      const specialCharacters = "!@#$%^&*()_-+=<>?/{}";

      // Şifreyi oluştur
      const randomUppercase = uppercaseLetters[Math.floor(Math.random() * uppercaseLetters.length)];
      const randomLowercase = lowercaseLetters[Math.floor(Math.random() * lowercaseLetters.length)];
      const randomNumber = numbers[Math.floor(Math.random() * numbers.length)];
      const randomSpecialCharacter = specialCharacters[Math.floor(Math.random() * specialCharacters.length)];

      const remainingLength = 8 - (randomUppercase.length + randomLowercase.length + randomNumber.length + randomSpecialCharacter.length);

     
      const randomChars = Array.from({ length: remainingLength }, () => {
        const allChars = uppercaseLetters + lowercaseLetters + numbers + specialCharacters;
        return allChars[Math.floor(Math.random() * allChars.length)];
      });
  
      const newPassword = randomUppercase + randomLowercase + randomNumber + randomSpecialCharacter + randomChars.join("");
      this.$set(this.form, 'password', newPassword);
      
    },

    close(){
      this.$parent.$bvModal.hide('modal-scoped')
    }
  },
};
</script>

<template>
  <b-modal id="modal-scoped" title="Bayi Ekle / Güncelle" size="lg" no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
      <div class="row d-flex flex-wrap mb-1" v-if="form.type!='password'">
        <label for="name" class="col-sm-4 col-form-label col-form-label">Firma Adı</label>
        <div class="col-sm-8">
          <input
            id="name"
            v-model="form.name"
            type="text"
            class="form-control"
            placeholder="Firma Adı"
            :class="{
              'is-invalid': submitted && $v.form.name.$error,
            }"
          />
          <div
            v-if="submitted && !$v.form.name.required"
            class="invalid-feedback"
          >
          Bu alanı doldurmak zorunludur.
          </div>
        </div>
      </div>
      <div class="row d-flex flex-wrap mb-1" v-if="form.type!='password'">
        <label for="authorized_name" class="col-sm-4 col-form-label col-form-label">Yetkili İsim Soyisim</label>
        <div class="col-sm-8">
          <input
            id="authorized_name"
            v-model="form.authorized_name"
            type="text"
            class="form-control"
            placeholder="Yetkili İsim Soyisim"
            :class="{
              'is-invalid': submitted && $v.form.authorized_name.$error,
            }"
          />
          <div
            v-if="submitted && !$v.form.authorized_name.required"
            class="invalid-feedback"
          >
          Bu alanı doldurmak zorunludur.
          </div>
        </div>
      </div>
      <div class="row d-flex flex-wrap mb-1" v-if="form.type!='password'">
        <label for="name" class="col-sm-4 col-form-label col-form-label">Yetkili Telefon</label>
        <div class="col-sm-8">
          <input
            id="phonenumber"
            v-model="form.phonenumber"
            type="text"
            class="form-control"
            placeholder="Yetkili Telefon"
            :class="{
              'is-invalid': submitted && $v.form.phonenumber.$error,
            }"
          />
          <div
            v-if="submitted && !$v.form.phonenumber.required"
            class="invalid-feedback"
          >
          Bu alanı doldurmak zorunludur.
          </div>
        </div>
      </div> 
      <div class="row d-flex flex-wrap mb-1" v-if="form.type!='password'">
        <label for="phonenumber1" class="col-sm-4 col-form-label col-form-label">Yetkili Telefon2</label>
        <div class="col-sm-8">
          <input
            id="phonenumber1"
            v-model="form.phonenumber1"
            type="text"
            class="form-control"
            placeholder="Yetkili Telefon2"
          />
        </div>
      </div>   
      <div class="row d-flex flex-wrap mb-1" v-if="form.type!='password'">
        <label for="username" class="col-sm-4 col-form-label col-form-label">Kullanıcı Adı</label>
        <div class="col-sm-8">
          <input
            id="username"
            v-model="form.username"
            type="text"
            class="form-control"
            placeholder="Kullanıcı Adı"
            :class="{
              'is-invalid': submitted && $v.form.username.$error,
            }"
          />
          <div
            v-if="submitted && !$v.form.username.required"
            class="invalid-feedback"
          >
          Bu alanı doldurmak zorunludur.
          </div>
        </div>
      </div> 
      <div class="row d-flex flex-wrap mb-1" v-if="form.type != 'update'">
        <label for="password" class="col-sm-4 col-form-label col-form-label">Şifre</label>
        <div class="col-sm-8">
          <div class="input-group mb-3">
            <input
              id="password"
              v-model="form.password"  
              type="text"
              class="form-control"
              placeholder="Şifre"
              :class="{
                'is-invalid': submitted && $v.form.password.$error,
              }"
            />
            <button class="btn btn-info" type="button" @click="generatePassword()">Şifre Oluştur</button>
            <div
              v-if="submitted && !$v.form.password.required"
              class="invalid-feedback"
            >
            Bu alanı doldurmak zorunludur.
            </div>
          </div>
        </div>
      </div>   
      <div class="row d-flex flex-wrap mb-1" v-if="form.type!='password'">
        <label for="ilce" class="col-sm-4 col-form-label col-form-label">İlçe</label>
        <div class="col-sm-8">
          <v-select
            label="name" 
            v-model="form.province_id"
            :options="ilList" 
            :reduce="country => country.id"
            @option:selecting="setSelected($event,'bucak')"><span slot="no-options">Sonuç Bulunamadı</span>
        </v-select>
        </div>
      </div> 
       <div class="row d-flex flex-wrap mb-1" v-if="form.type!='password'">
        <label for="bolge" class="col-sm-4 col-form-label col-form-label">Bölge</label>
        <div class="col-sm-8">
          <v-select 
            label="name"  
            v-model="form.district_id"                    
            :options="bucakList" 
            :reduce="country => country.id"><span slot="no-options">Sonuç Bulunamadı</span>
          </v-select>
        </div>
      </div> 
       <div class="row d-flex flex-wrap mb-1" v-if="form.type!='password'">
        <label for="address" class="col-sm-4 col-form-label col-form-label">Adres</label>
        <div class="col-sm-8">
          <input
            id="address"
            v-model="form.address"
            type="text"
            class="form-control"
            placeholder="Adres"
            :class="{
              'is-invalid': submitted && $v.form.address.$error,
            }"
          />
          <div
            v-if="submitted && !$v.form.address.required"
            class="invalid-feedback"
          >
          Bu alanı doldurmak zorunludur.
          </div>
        </div>
      </div> 
      <div class="row d-flex flex-wrap mb-1" v-if="form.type!='password'">
        <label for="description" class="col-sm-4 col-form-label col-form-label">Açıklama</label>
        <div class="col-sm-8">
          <input
            id="description"
            v-model="form.description"
            type="text"
            class="form-control"
            placeholder="Açıklama"
          />
        </div>
      </div> 
      <div class="row d-flex flex-wrap mb-1" v-if="form.type!='password'">
        <label for="limit" class="col-sm-4 col-form-label col-form-label">Limit TL</label>
        <div class="col-sm-8">
          <input
            id="limit"
            v-model="form.limit"
            type="text"
            class="form-control"
            placeholder="Limit TL"
          />
        </div>
      </div>
      <div class="row d-flex flex-wrap mb-1" v-if="form.type!='password'">
        <label for="adsl_com" class="col-sm-4 col-form-label col-form-label">Adsl Komisyonu %</label>
        <div class="col-sm-8">
          <input
            id="adsl_com"
            v-model="form.adsl_com"
            type="text"
            class="form-control"
            placeholder="Adsl Komisyonu"
          />
        </div>
      </div>
      <div class="row d-flex flex-wrap mb-1" v-if="form.type!='password'">
        <label for="wireless_com" class="col-sm-4 col-form-label col-form-label">Wireless Komisyonu %</label>
        <div class="col-sm-8">
          <input
            id="wireless_com"
            v-model="form.wireless_com"
            type="text"
            class="form-control"
            placeholder="Wireless Komisyonu"
          />
        </div>
      </div>
      <div class="row d-flex flex-wrap mb-1" v-if="form.type!='password'">
        <label for="adsl_com" class="col-sm-4 col-form-label col-form-label">Adsl Dış Komisyonu %</label>
        <div class="col-sm-8">
          <input
            id="adsl_com"
            v-model="form.adsl_dis_com"
            type="text"
            class="form-control"
            placeholder="Adsl Komisyonu"
          />
        </div>
      </div>
      <div class="row d-flex flex-wrap mb-1" v-if="form.type!='password'">
        <label for="wireless_com" class="col-sm-4 col-form-label col-form-label">Wireless Dış Komisyonu %</label>
        <div class="col-sm-8">
          <input
            id="wireless_com"
            v-model="form.wireless_dis_com"
            type="text"
            class="form-control"
            placeholder="Wireless Komisyonu"
          />
        </div>
      </div>
      <div class="row d-flex flex-wrap mb-1" v-if="form.type!='password'">
        <label for="formCheckcolor1" class="col-sm-8 col-form-label col-form-label">Eklediği Müşteri Onaydan Geçsin </label>
        <div class="col-sm-4 mt-2">
         <div class="form-check form-check-primary mb-3  text-end">
          <input class="form-check-input" v-model="form.add_confirmation" type="checkbox" value="1" id="formCheckcolor1">
          </div>
        </div>
      </div> 
      
      <div class="d-flex justify-content-between mt-3">
        <div>
          <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
        </div>
        <div>
          <b-button variant="light" @click="close()">Vazgeç</b-button>
          <b-button 
            v-if="form.id"
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
          </b-button>
          <b-button 
            v-else
            type="submit" 
            variant="success" 
            class="ms-1"
            >Oluştur
          </b-button>
        </div>
        </div>
      </form>
    </b-modal>
</template>